module.exports = "img/photo1.f4c9ee.jpeg";